/** Lowercase, trim, collapse spaces for matching. */
export function normalizeSlotText(input: string): string {
  return input
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ');
}
